import { ensureArray } from "@buurman/commons";
import { shell } from "../shell";

export interface NpmApi {
    command(command: string, args?: string[]): this;

    init(): this;
    update(): this;
    install(packages?: string | string[], flags?: string[]): this;

    execute(): Promise<void>;
}

const npm = () => {
    const commands: string[][] = [];

    const api: NpmApi = {
        command: (command, args = []) => {
            commands.push([command, ...args]);
            return api;
        },

        init: () => api.command("init", ["-y"]),
        update: () => api.command("update"),
        install: (packages, flags = []) => {
            api.command(
                "install",
                [...flags, ...ensureArray(packages)].filter(Boolean),
            );

            return api;
        },

        execute: async () => {
            for (const args of commands) {
                await shell().exec("npm", args);
            }
        },
    };

    return api;
};

export default npm;
